// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"283f96f2","952":"4c4288ad"}[chunkId] + ".chunk.js";
};